module.exports = __webpack_public_path__ + "static/media/insta_deactive.742a2fd3.png";